import Button from '@shared/components/Button/Button';
import Divider from '@shared/components/Divider/Divider';
import Popup from '@shared/components/Popup/Popup';
import { useTranslation } from 'react-i18next';

import { WorkspaceRoleV2 } from 'modules/CreateWorkspaceModal/types';

import RolePermissionsReadOnlyPanel from '../WorkspaceRolesSetting/RolePermissionsReadOnlyPanel';

interface UneditableRoleProps {
  role: WorkspaceRoleV2;
  onClose: () => void;
}

const UneditableRole = ({ role, onClose }: UneditableRoleProps) => {
  const { t } = useTranslation();

  return (
    <Popup isVisible closePopup={onClose} wrapperId="workspace-role-edit-modal">
      <Popup.FullScreenContainer className="md:w-[658px] md:max-w-[658px]">
        <div className="px-4">
          <Popup.Header className="shadow-none border-none !mx-0">
            <span className="text-size-md font-medium">{t('workspace_roles.view.title')}</span>
            <Popup.CloseIcon closePopup={onClose} className="!right-0" />
          </Popup.Header>
          <Divider className="hidden md:block" />
        </div>
        <div className="flex flex-col grow overflow-y-auto gap-4 px-4 md:pt-4">
          <RolePermissionsReadOnlyPanel role={role} />
        </div>
        <Popup.Footer wrapperClassName="!pb-4 !px-0" className="w-full !pt-4 !px-4 justify-center sm:justify-end">
          <Button variant="tertiary" className="w-full md:w-fit" onClick={onClose}>
            {t('cancel')}
          </Button>
        </Popup.Footer>
      </Popup.FullScreenContainer>
    </Popup>
  );
};

export default UneditableRole;
